import NavBar from "../../../subComponent/NavBar";
import duty from "../../../Assets/Img/duty.png";
import weighttracking from "../../../Assets/Img/duty.png";
import storybag from "../../../Assets/Img/storybag.webp";
import codelabeling from "../../../Assets/Img/codelabeling.webp";
import storybrand from "../../../Assets/Img/storybrand.webp";
import inhension from "../../../Assets/Img/inhension.webp";
import cost from "../../../Assets/Img/cost.webp";
import challenge from "../../../Assets/Img/challenge.webp";
import dummyimage from "../../../Assets/Img/dummyimage.webp";
import trackingmobile from "../../../Assets/Img/trackingmobile.webp";
import challengeimage from "../../../Assets/Img/challengeimage.webp";
import requestform from "../../../Assets/Img/requestform.webp";
import productdevelopment from "../../../Assets/Img/productdevelopment.webp";
import erpsolution from "../../../Assets/Img/erpsolution.webp";
import clientchallenge from "../../../Assets/Img/clientchallenge.webp";
import multiple from "../../../Assets/Img/multiple.webp";
import internetconnection from "../../../Assets/Img/internetconnection.webp";
import saccode from "../../../Assets/Img/saccode.webp";
import casegraph from "../../../Assets/Img/casegraph.png";
import qrcode from "../../../Assets/Img/qrcode.png";
import urlstock from "../../../Assets/Img/urlstock.webp";
import clienttable from "../../../Assets/Img/clienttable.webp";
import stockcutting from "../../../Assets/Img/stockcutting.webp";
import Footer from "../../../subComponent/Footer";
import Data from './Data'
import RequestForm from "../../../subComponent/RequestForm";

const Story = () => {
    return (
        <>
            <div className="bg-white">
                <div className="background-setting top-banner-background">
                    <div className="inventory-backdrop p-0" >
                        <div className="py-5">
                            <NavBar />
                            <p className="text-center text-white fs_30  poppins m-0 pb-3  ">Success Stories</p>

                        </div>
                    </div>

                </div>

                <div className="background-setting story-background my-4">
                    <div className="inventory-backdrop p-0" >
                        <div class="line-before text-white fs_19">Success Stories </div>
                        <div className="container">
                            <div className="py-5 px-3 px-md-5">
                                <p className="sales-text text-white  fs_30 poppins m-0 pb-3   ">Understand What We've Done,And You'll KnowWhat We Can Do</p>
                                <p className="sales-descrption text-white f  poppins m-0  ls_2  fs_19">At SmartB, we have our Tech Squad who is dedicated to (1) understanding and (2) designing solutions that meet our client’s requirement.</p>
                                <p className="sales-descrption text-white f  poppins m-0  ls_2  fs_19">Once we have the scope clarified, we design solutions that suite your business needs, whatever they may be. Understand our past projects and you’ll understand more about us.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="background-setting use-cases-background my-4">
                    <div className="inventory-backdrop p-0" >
                        <div class="line-before text-white fs_19">Stories </div>
                        <div className="container">
                            <div className="py-5 px-3 px-md-5">
                                <p className="sales-text text-white  fs_30 poppins m-0 pb-3   ">
                                    Success Stories / Use Cases</p>
                                <p className="sales-descrption text-white   poppins m-0  ls_2  fs_19 pb-3">“If you can design one thing you can design everything.”</p>
                                <p className="sales-descrption text-white   poppins m-0  ls_2  fs_19 pb-3">While we cannot quantify everything that we are capable of doing, we hope to at least demonstrate our skills through some of the past projects that we have done.</p>
                                <p className="sales-descrption text-white  poppins m-0  ls_2  fs_19">As you explore more of our services and offerings, you can begin to see how we combine our skills and capabilities in some of our projects in order to help our customers achieve the results that they required.

                                    With that, here are some of the use cases.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row services-wrapper py-5">
                        {Data.map(each => (
                            <div className="col-12 col-sm-6 col-lg-4">
                                <div className="background-setting " style={{ backgroundImage: `url(${each.Img})` }}>
                                    <div className="inventory-backdrop p-0" >
                                        <div className="inventory-header d-flex justify-content-center align-items-center flex-column py-5">
                                            <div className="case-icon">
                                                <img src={each.Iconimage} width="100px" />
                                            </div>
                                            <p className="inventory-heading text-center text-white fw-700 fs_19 mb-0 mt-4">{each.heading}</p>
                                            <p className="services-paragraph ls_3 text-center text-white futura fs_14">{each.text}</p>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                        )}
                    </div>
                </div>
                <div className="background-setting case1-banner-background p-0 ">
                    <div className="inventory-backdrop p-0" >
                        <div className="py-3">
                            <p className=" text-white fs_19 px-5 poppins m-0 pb-3  ">Case 1:</p>
                            <p className="text-center text-white fs_22  poppins m-0 pb-3  ">Integrated Weight, Print & Mobile Tracking</p>

                        </div>
                    </div>

                </div>
                <div className="sales-module_heading mt-5 ">
                    <p className="benefit-text text-white poppins fs_30">Sales Module</p>
                </div>
                <div className="row w-100 my-5 ">
                    <div className=" sales-module-text col-12 col-md-7 p-5">
                        <p className=" text-white  poppins fs_13 ls_2">The client, Diyou Fibre (M) Sdn. Bhd. (DF), is a fibre manufacturer who was trying to track their work-in-progress (WIP) stock at multiple stages of their production process.
                            While tracking WIP goods is slightly more straight-forward if the goods were in constant production flow, this was not the case for DF. In fact, their production was based on the fluctuating demand of their clients. To make things more complicated, DF would also sell some of these WIP stocks as soon as there’s a willing buyer.</p>
                        <p className="text-white poppins fs_13 ls_2">SmartB was given the task to help track (and trace) the WIP stocks, starting from the raw material stage, all the way till the goods leave the warehouse. Stocks that are kept in the warehouse will be traceable too.
                            The WIP stocks are usually kept in a bag (weighing between 200-300kg) and simple records of its production needs to be tracked as well. There is 3 warehouses where the goods are kept.</p>
                        <p className="text-white poppins fs_13 ls_2">Lastly, most of the staff involve in the production are foreign workers who cannot speak or read English.</p>
                    </div>
                    <div className="col-12 col-md-5  sales-module_image">
                        <img src={storybag} width="100%" alt="Your image" />
                    </div>
                </div>
                <div className="sales-module_heading my-5 ">
                    <p className="benefit-text text-white poppins fs_30">The Challenge</p>
                </div>
                <div className="col-12 challenge_image">
                    <img src={challenge} width="100%" alt="Your image" />
                </div>
                <div className="row w-100 my-5 ">
                    <div className="col-12 col-md-7 background-setting trading-background my-4 p-0">
                        <div className="inventory-backdrop p-0" >
                            <div className="container">
                                <div className="py-5 px-3 px-md-5">
                                    <p className="sales-text text-white  fs_30 poppins m-0 pb-3   ">
                                        Heavy Duty, Touch Screen,<br /> Reasonable Cost</p>
                                    <p className="sales-descrption text-white   poppins m-0 fs_16    pb-3">The first part of the solution was to figure out how to make we captured data conveniently and accurately. Using keyboards and mouse would not work as that is more suitable for office or administrative type of operations.</p>
                                    <p className="sales-descrption text-white   poppins m-0 fs_16 pb-3">Hence, the answer was definitely to use touch screen. While a tablet would work, a touch screen terminal would be even better. In fact, most of the terminals that we sourced are designed to be heavy duty but at a reasonable cost.</p>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-5 pt-0  mt-3 mt-md-4 d-flex align-items-center sales-module_image">
                        <img src={duty} width="100%" alt="Your image" />
                    </div>
                </div>
                <div className="row w-100 my-5 ">
                    <div className="col-12 col-md-7 background-setting weigh-tracking-background my-4 p-0">
                        <div className="inventory-backdrop p-0" >
                            <div className="container">
                                <div className="py-5 px-3 px-md-5">
                                    <p className="sales-text text-white  fs_30 poppins m-0 pb-4   ">
                                        Integrated Weight <br />Tracking</p>
                                    <p className="sales-descrption text-white   poppins m-0 fs_16  pb-4">The customer wants to track their goods. Since these are manufactured in mini pallets, the best way to keep track them was to have weight record with each bag.</p>
                                    <p className="sales-descrption text-white   poppins m-0 fs_16 pb-4 ">The bag in the image above is a similar type of bag used on DF.</p>
                                    <p className="sales-descrption text-white   poppins m-0 fs_16 pb-4 ">As part of the move towards paperless, we manage to integrate the weight reader with our terminal. Hence, allowing the client to record the weight of the bags as they are produced. This would also instantly record the time of manufacturing each bag and, indirectly, the production rate.</p>
                                    <p className="sales-descrption text-white   poppins m-0  fs_16 pb-4">Another thing to note is that our system is a cloud base solution. Hence, all data captured are instantly accessible online.</p>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-5 pt-0  mt-3 mt-md-4 d-flex align-items-center sales-module_image ">
                        <img src={weighttracking} width="100%" alt="Your image" />
                    </div>
                </div>
                <div className="row w-100 my-5 ">
                    <div className="col-12 col-md-8 background-setting mobile-scanner-background my-4 p-0">
                        <div className="inventory-backdrop p-0" >
                            <div className="container">
                                <div className="py-5 px-3 px-md-5">
                                    <p className="sales-text text-white  fs_30 poppins m-0 pb-4  ">
                                        Creative QR Code Labelling</p>
                                    <p className="sales-descrption text-white   poppins m-0 fs_16  pb-3">The next task was to ensure that all the bags could be traced. Naturally, the solution was to create a label sticker.</p>
                                    <p className="sales-descrption text-white   poppins m-0 fs_16 pb-4 ">However, since the bags were kept in a dusty environment, we manage to create labels that are similar to those luggage labels used at the airport. Simple details were printed. More importantly, each bag would now have a serial numbered QR Code..</p>
                                    <p className="sales-descrption text-white   poppins m-0 fs_16 pb-4 ">Lastly, the bag numbers were all unique, which means we had to serialize them. And there’s no better way to do it other than doing it from our system – especially since the bags will be traced from our mobile app (below).</p>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-4 pt-0  mt-3 mt-md-4 d-flex align-items-center sales-module_image creative-code p-0">
                        <img src={codelabeling} width="100%" alt="Your image" />
                    </div>
                </div>
                <div className="background-setting dummy-story-background my-4">
                    <div className="inventory-backdrop p-0" >
                        <div className="container">
                            <div className="py-5">
                                <p className="text-white text-center fs_32 poppins m-0  ">
                                    A Dummy-Proof System</p>
                                <p className="dummy-content text-white  poppins m-0  ls_2  fs_19 py-5">As the production workers are predominantly foreigners, we had to design a dummy proof system – big fonts, big buttons and limited words.</p>
                                <p className="dummy-content text-white   poppins m-0  ls_2  fs_19 ">Again, with some basic training, the system was merely one that requires a few click of buttons.</p>
                                <div className="dummy-image pt-5">
                                    <img src={dummyimage} width="100%" alter="your image" />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div className="background-setting mobile-tracking-background my-5 p-0">
                    <div className="inventory-backdrop p-0" >

                        <div className="container">
                            <div className="py-5 px-3 px-md-5">
                                <p className="sales-text text-white  fs_32 poppins m-0 pb-5   ">Mobile Tracking</p>
                                <p className="sales-descrption text-white  poppins m-0  ls_2  fs_16 pb-4 ">Because the goods (in the bags) were all over the warehouse and they were mostly 200+kg, the most convenient way to (1) track these goods and (2) capture movement data at the same time, it was to use the device that many people had – including foreign workers. Hence, a mobile app solution was delivered as part of the solution.</p>
                                <p className="sales-descrption text-white f  poppins m-0  ls_2  fs_16 pb-4">With this, nearly all movement of goods can be captured. This was done with the help of QR Code scanning on smart phones that was done through SmartB’s mobile app.</p>
                                <p className="sales-descrption text-white f  poppins m-0  ls_2  fs_16">Also, utilizing the fact that most smart phones have cameras attached to it, DF could also capture picture evident of their goods being delivered..</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="sales-module_heading mt-5 ">
                    <p className="benefit-text text-white poppins fs_30">The Result</p>
                </div>
                <div className="row w-100 my-5  ">
                    <div className=" sales-module-text col-12 col-md-7 p-5">
                        <p className=" text-white  poppins fs_16 ls_2">A challenging project where SmartB had to utilize many unconventional ideas before narrowing down the options to create a suitable and practical solution.
                        </p>
                        <p className="text-white poppins fs_16 ls_2">before narrowing down the options to create a suitable and practical solution.

                            As shown above, this was one successful and creative project delivered for a very unconventional tracking case</p>
                    </div>
                    <div className="col-12 col-md-5">
                    </div>
                </div>
                {/* Case-2 */}
                <div className="background-setting case2-banner-background p-0">
                    <div className="inventory-backdrop p-0" >
                        <div className="py-3 my-5">
                            <p className=" text-white fs_19 px-5 poppins m-0 pb-3  ">Case 2:</p>
                            <p className="text-center text-white fs_22  poppins m-0 pb-3  ">Custom-Built CRM For New Product Development <br /> Processing & Controls</p>
                        </div>
                    </div>
                </div>
                <div className="sales-module_heading challenge-text mt-5 ">
                    <p className="benefit-text text-white poppins fs_30">Client Requirement</p>
                </div>
                <div className="row w-100 my-5 ">
                    <div className=" sucess-challenge col-12 col-md-8 p-5">
                        <p className=" sucess-challenge_content text-white  poppins fs_16 ls_2">The client, Inhesion Industrial (M) Sdn. Bhd. (IM), is a tableware manufacturer who was trying to implement an end-to-end ERP system which predominantly include the Sales, Product Development, Production, Inventory and Accounting modules.</p>
                        <p className="sucess-challenge_content text-white poppins fs_16 ls_2">This use case is to describe a custom-made module for their Product Development management. As shown in the image above, Inhesion specialises in custom made and custom design tableware..</p>

                        <p className="sucess-challenge_content text-white poppins fs_16 ls_2 ">For this project, SmartB worked very closely with IM for several months to first identify the requirements before building the modules.</p>
                    </div>
                    <div className="col-12 col-md-4 d-flex align-items-center mt-md-0 mt-4  sales-module_image  challenge-image">
                        <img src={storybrand} width="100%" alt="Your image" />
                    </div>
                </div>
                <div className="sales-module_heading challenge-text mt-5 ">
                    <p className="benefit-text text-white poppins fs_30">The Challenge</p>
                </div>
                <div className="row w-100 my-5 ">
                    <div className=" sucess-challenge col-12 col-md-8 p-5">
                        <p className=" sucess-challenge_content text-white  poppins fs_16 ls_2">IM has sales representatives in various parts of the world. The diagram above shows the process of each new request submitted to the production team and how the approval processes were made right until the birth of a new product for sales.</p>
                        <p className="sucess-challenge_content text-white poppins fs_16 ls_2">All there were important because these new products, when developed, need to ensure that all production cost, quality and profitability are assured and within their expected range.</p>
                        <p className="sucess-challenge_content text-white poppins fs_16 ls_2">SmartB’s challenge was (1) to understand the end-to-end process before (2) ensuring the feasibility of the design that was being built. Lastly, (3) to ensure the good user interface (UI) and user experience (UX) were achieved.</p>
                        <p className="sucess-challenge_content text-white poppins fs_16 ls_2">Essentially, and metaphorically, SmartB was like the architect and the builder at the same time.</p>

                    </div>
                    <div className="col-12 col-md-4 mt-md-0 mt-4  d-flex align-items-center mt-sm-3 sales-module_image challenge-image">
                        <img src={challengeimage} width="100%" alt="Your image" />
                    </div>
                </div>
                <div className="sales-module_heading challenge-text mt-5 ">
                    <p className="benefit-text text-white poppins fs_30">Implementation</p>
                </div>
                <div className="row w-100 my-5  ">
                    <div className="sucess-challenge col-12 col-md-7 p-5">
                        <p className=" text-white  poppins fs_16 ls_2">As this was considered a mid to large size project, we broke it down into sizable chunks.
                        </p>
                        <p className="text-white poppins fs_16 ls_2">Essentially to deliver it by multiple phases.</p>
                    </div>
                    <div className="col-12 col-md-5">
                    </div>

                    <div className="row py-3 py-md-5">
                        <div className="col-12 col-md-6">
                            <img src={requestform} width="100%" alt="Your image" />

                        </div>
                        <div className="col-12 col-md-6">
                            <img src={productdevelopment} width="100%" alt="Your image" />

                        </div>

                    </div>
                </div>
                <div className="row w-100 my-5  ">
                    <div className="case-5-text col-12 col-md-10 p-5">
                        <p className=" text-white  poppins fs_16 ls_2 pb-4">Apart from having a tight budget, Taiko needed a SmartB to help them formulate the algorithm to significantly reduce non-production activities (e.g. switching and/or setting up new machines) while regularly updating the production priority based on short-term urgent requests.
                        </p>
                        <p className="text-white poppins fs_16 ls_2 pb-4">If this was not hard enough, it took Taiko a significant amount of time to conceptualise what they needed as this module was very new to them. Basically, they had a vision of what they wanted, but didn’t know how to explain it in simple terms.
                        </p>
                        <p className="text-white poppins fs_16 ls_2 ">Note: In order to maintain confidentiality, the information in this case were altered. However, rest assured that the complexity of the requirements remains at similar levels.
                        </p>
                    </div>

                    <div className="col-12 col-md-6 mt-5">
                        <div className="background-setting request-background my-4 p-0">
                            <div className="inventory-backdrop p-0" >
                                <div className=" py-5 px-5">
                                    <div className="container">
                                        <p className=" text-center sales-text text-white  fs_30 poppins m-0 pb-4">Request Entry</p>
                                        <p className=" implementation-contnet  text-white poppins m-0 pb-4 fs_16">The goal was to immediately digitize and streamline the process. Hence, no more physical forms or even emails allowed.
                                        </p>
                                        <p className="implementation-contnet  text-white poppins m-0 pb-4 fs_16">With that in mind, the first thing we built was an digital request form where any requester would need to fill in the request form online.
                                        </p>
                                        <p className=" implementation-contnet  text-white poppins m-0 pb-4 fs_16">As soon as they submit the form, the request is immediately logged into the database.
                                        </p>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="background-setting ease-background my-4 p-0">
                            <div className="inventory-backdrop p-0" >
                                <div className=" py-5 px-3 px-md-5">
                                    <div className="container">
                                        <p className=" 
                                        sales-text text-white  fs_30 poppins m-0 pb-4">Ease Of Usage</p>
                                        <p className=" implementation-contnet  text-white poppins m-0 pb-4 fs_16">As the project was complex, the need to remain focus was crucial. So, instead of building a “robot”, the idea was to focus what was important.

                                        </p>
                                        <p className=" implementation-contnet  text-white poppins m-0 pb-4 fs_16">That means, we focused on optimising the production sequence only. And that would have meant that the bulk of the requirements would have been met.
                                        </p>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 mt-3 mt-md-5 ">
                        <div className="background-setting management-background my-4 p-0">
                            <div className="inventory-backdrop p-0" >
                                <div className=" py-5 px-3 px-md-5">
                                    <div className="container">
                                        <p className="text-end sales-text text-white  fs_32 poppins m-0 pb-4   ">Request Management</p>
                                        <p className="text-end implementation-contnet  text-white   poppins m-0 pb-4 fs_16">Once the request has been submitted, the person-in-charge (PIC) is next to take action.

                                        </p>
                                        <p className="text-end implementation-contnet text-white   poppins m-0 pb-4 fs_16">As you can see, the request needs to be managed and a simple dashboard was built for that. Multiple tabs were also added as this were different parts of the request.
                                        </p>
                                        <p className="text-end implementation-contnet text-white   poppins m-0 pb-4  fs_16">Blind Spots
                                        </p>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="background-setting result-background my-4 p-0">
                            <div className="inventory-backdrop p-0" >
                                <div className=" py-5 px-3 px-md-5">
                                    <div className="container">
                                        <p className=" text-end sales-text text-white  fs_32 poppins m-0 pb-4   ">The Result</p>
                                        <p className="text-end implementation-contnet  text-white   poppins m-0 pb-4 fs_16">A 100% custom-made system was built from scratch.

                                        </p>
                                        <p className="text-end implementation-contnet text-white   poppins m-0 pb-4 fs_16">Thanks to the strong emphasis made on the design and planning stage, the new system was delivered – meeting nearly all the requirements made by the IM.
                                        </p>
                                        <p className="text-end implementation-contnet text-white   poppins m-0 pb-4  fs_16">Furthermore, building this system on top of our standard modules also mean that IM can further benefit from the existing system. A synergistic effect where 1 + 1 = 3.
                                        </p>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
                {/* Case-3 */}
                <div className="background-setting case3-banner-background">
                    <div className="inventory-backdrop p-0" >
                        <div className="py-3 my-5">
                            <p className=" text-white fs_19 px-5 poppins m-0 pb-3  ">Case 3:</p>
                            <p className="text-center text-white fs_22  poppins m-0 pb-3  ">End-To-End Tracking: Challenges From The Factories</p>
                        </div>
                    </div>
                </div>
                <div className="sales-module_heading client-section mt-5 ">
                    <p className="benefit-text text-white poppins fs_30">Client Requirement</p>
                </div>
                <div className="row w-100 my-5 ">
                    <div className="client-challenge-background  col-12 col-md-7 p-5">
                        <p className=" sucess-challenge_content text-white  poppins fs_16 ls_2 pb-3">The client, V’Asia Cosmetic & Healthcare (VA), is a health and beauty brand owner who was trying to implement an end-to-end tracking system.</p>
                        <p className="sucess-challenge_content text-white poppins fs_16 ls_2">This is important because, as the VA becomes a more reputable brand in the marketplace, they are faced with integrity and social challenges. Some of these includes:</p>
                        <ul className="py-3">
                            <li className="text-white poppins fs_16">Mis-match of data between VA and their distributors   </li>
                            <li className="text-white poppins fs_16">Product traceability, and    </li>
                            <li className="text-white poppins fs_16 ">Product authenticity claims </li>

                        </ul>
                        <p className="sucess-challenge_content text-white poppins fs_16 ls_2">Also, VA is no longer a small company, without a proper tracking system, some of the operational challenges can be quite costly.</p>

                    </div>
                    <div className="col-12 col-md-5 pt-5 mt-3 challenge-image ">
                        <img src={clientchallenge} width="100%" alt="Your image" />
                    </div>
                </div>
                <div className="sales-module_heading client-section mt-5 ">
                    <p className="benefit-text text-white poppins fs_30">The Challenge</p>
                </div>
                <div className=" client-challenge-section flex-sm-column-reverse flex-md-row d-md-flex justify-content-between gap-5 w-100 my-5 ">
                    <div className=" client-challenge-background  p-5">
                        <div className="inner-column">
                            <p className=" sucess-challenge_content text-white  poppins fs_16 ls_2 pb-3">The client wanted a system to trace all stock movement starting from where the goods were manufactured.
                            </p>
                            <p className="sucess-challenge_content text-white poppins fs_16 ls_2">That means, the data capture of the end-to-end flow needs to start at all the manufacturing sites. The client presented us with 5 manufacturing sites which were predominantly based outside the city.
                            </p>

                            <p className="sucess-challenge_content text-white poppins fs_16 ls_2  ">However, as some of you can imagine, not all locations/site has good internet connection. This issue alone made the project extremely tricky.
                            </p>
                        </div>

                    </div>
                    <div className=" client-challenge-background   p-5 mt-4 mt-md-0">
                        <p className=" sucess-challenge_content text-white  poppins fs_16 ls_2 pb-3">The process flow for this task is probably a simple one where the factories produces the goods, they box the goods up (in bulk) and dispatch it to VA’s warehouse. As soon as there’s a customer order, VA would pack the necessary order for further dispatch.
                        </p>
                        <p className="sucess-challenge_content text-white poppins fs_16 ls_2">Hence, the real challenge lies not in the complexity of the process but in the complexity of the implementation and set up.
                        </p>

                        <p className="sucess-challenge_content text-white poppins fs_16 ls_2">Hopefully, by understanding these challenges, it illustrates the level of difficulties faced.
                        </p>

                    </div>
                </div>
                <div className="col-12 challenge_image">
                    <img src={multiple} width="100%" alt="Your image" />
                </div>
                <div className="sales-module_heading client-section mt-5 ">
                    <p className="benefit-text text-white poppins fs_30">Implementation</p>
                </div>
                <div className="row w-100 my-5 ">
                    <div className="col-12 col-md-7 background-setting internet-image-background my-4 p-0">
                        <div className="inventory-backdrop p-0" >
                            <div className="container">
                                <div className="py-5 px-3 px-md-5">
                                    <p className="sales-text text-white  fs_30 poppins m-0 pb-4 ">
                                        Internet Connection</p>
                                    <p className="implementation-descrption text-white   poppins m-0 fs_16  pb-3">The first few factories where we installed the system were located in an area where internet connection (LAN) was poor.</p>
                                    <p className="implementation-descrption text-white   poppins m-0 fs_16 pb-4 ">Without spending any money, and along with a few rounds of tests (trial and error), we managed to identify a solution that gives the most stable connection.</p>
                                    <p className="implementation-descrption text-white   poppins m-0 fs_16 pb-4 ">Note: At the time of writing this, the client has already been successfully using the hot spot as a solution for the last 6 months with a monthly internet fee of only RM110+ per month.</p>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-5 d-flex align-items-center  mt-sm-3   sales-module_image">
                        <img src={internetconnection} width="100%" alt="Your image" />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-md-10">
                        <div className="background-setting scannig-location-background my-4 p-0">
                            <div className="inventory-backdrop p-0" >
                                <div className=" py-5 px-3 px-md-5">
                                    <div className="container">
                                        <p className="sales-text text-white  fs_30 poppins m-0 pb-3   ">Scanning Location In Each Factory</p>
                                        <p className="implementation-contnet  text-white f  poppins m-0  ls_2  fs_16">In line with the above, we worked closely with the client to identify strategic locations within each factory in order to ensure that</p>
                                        <ul className="py-3">
                                            <li className="text-white poppins fs_16">The internet signals were stable
                                            </li>
                                            <li className="text-white poppins fs_16">It is convenient for the production team
                                            </li>
                                            <li className="text-white poppins fs_16 ">Data collected were relevant</li>
                                        </ul>
                                        <p className="implementation-contnet text-white f  poppins m-0  ls_2  fs_16">Another challenge was due to the fact that, for hygiene purposes (for food manufacturers), some of the factory were insulated. Hence, internet signals were weaker at certain points.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-2">
                    </div>
                    <div className="col-12 col-md-2">
                    </div>
                    <div className="col-12 col-md-10 mt-5">
                        <div className="background-setting stock-number-background my-4 p-0">
                            <div className="inventory-backdrop p-0" >
                                <div className=" pt-5 px-3 px-md-5">
                                    <div className="container">
                                        <p className="text-end text-white  fs_30 poppins m-0 pb-4   ">QR Code-URL -Stock Number <br />Conversion</p>
                                        <p className="text-end  text-white  poppins m-0  ls_2 pb-4 fs_16">The next challenge that we faced during implementation was the fact that the client was using anti-tempering QR code stickers (see image) which displayed serialize numbers.</p>

                                        <p className="text-end text-white f  poppins m-0  ls_2 pb-4  fs_16">Unfortunately, the data that was scanned from the codes were URL links – the webpages from the link were displaying VA’s company information.</p>
                                        <p className="text-end text-white f  poppins m-0  ls_2  fs_16">In order to proceed, we had to collaborate with the sticker manufacturer (Packtica Sdn Bhd) to get the mapping data between the URLs and the serialize stock numbers.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-10 mt-5">
                        <div className="background-setting serial-number-background my-4 p-0">
                            <div className="inventory-backdrop p-0" >
                                <div className=" py-5 px-3 px-md-5">
                                    <div className="container">
                                        <p className="sales-text text-white  fs_30 poppins m-0 pb-4   ">Registering Serial Numbers To The <br></br>Product And Box</p>
                                        <p className="implementation-contnet  text-white f  poppins m-0  ls_2  fs_16">As the stickers were distributed randomly to various factories, there was no way we could to identify the serial number used in any production plant in advance.</p>
                                        <ul className="py-3">
                                            <li className="text-white poppins fs_16">This must be done as soon as the sticker was pasted on the product

                                            </li>
                                            <li className="text-white poppins fs_16">It must be done quickly as the product moves along the conveyor belt

                                            </li>
                                            <li className="text-white poppins fs_16 ">It must be done immediately before the products were packed into its box</li>
                                        </ul>
                                        <p className="implementation-contnet text-white   poppins m-0  ls_2  fs_16">Meanwhile, the system would also group that specific range of serial numbers to specific boxes.</p>
                                        <p className="implementation-contnet text-white   poppins m-0  ls_2  fs_16">Lastly, with the information from the product profile, we had to instruct the system to print the box labels according box capacity. E.g. if the box could only accommodate 30 bottles, the printer would print a new label as soon as the 30th QR sticker was scanned.</p>
                                        <p className="implementation-contnet text-white   poppins m-0  ls_2  fs_16">That way, we could identify the range of serial numbers moving in that specific box each time we scanned each individual box.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-2">
                    </div>
                    <div className="col-12 col-md-4 mt-5 px-2 px-md-0 sales-module_image d-flex align-items-center">
                        <img src={saccode} width="100%" alt="Your image" />
                    </div>
                    <div className="col-12 col-md-8 mt-5">
                        <div className="background-setting box-label-background my-4 p-0">
                            <div className="inventory-backdrop p-0" >
                                <div className=" pt-5 px-3 px-md-5">
                                    <div className="container">
                                        <p className="sales-text text-white  fs_30 poppins m-0 pb-4 ">Box Label To Display Each Serial Code</p>
                                        <p className="text-end  text-white  poppins m-0  ls_2 pb-4 fs_16">Looking at the label above, you can see that the range of serial numbers are displayed on the box label.
                                        </p>
                                        <p className="text-end text-white f  poppins m-0  ls_2 pb-4  fs_16">Because this is a semi-automation process, some of the warehouse staff still needs to visibly see the range of serial numbers use for that specific box.</p>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-11 mt-5">
                        <div className="background-setting scanning-speed-background my-4 p-0">
                            <div className="inventory-backdrop p-0" >
                                <div className=" py-5 px-3 px-md-5">
                                    <div className="container">
                                        <p className="sales-text text-white  fs_30 poppins m-0 pb-4   ">Scanning Speed For Stock Arrival</p>
                                        <p className="implementation-contnet  text-white f  poppins m-0   pb-4 fs_16">Imagine this, you have 300 boxes arriving in the warehouse (from the factories), each box holds 50 units of health packets and you need to register the serial number of each item entering the warehouse in less than 30 minutes.
                                        </p>
                                        <p className="implementation-contnet text-white   poppins m-0   pb-4 fs_16">In other words, we need to know which are the exact 15,000 serialize products that has entered the warehouse in that duration. Yet, the production was only a semi-automated process, the WIP goods are moving as fast as the conveyor could move but tasks were predominantly executed by manual labour.
                                        </p>
                                        <p className="implementation-contnet text-white   poppins m-0  pb-4  fs_16">That was the task assigned to SmartB.
                                        </p>
                                        <p className="implementation-contnet text-white   poppins m-0  pb-4 fs_16">The first thing was to integrate a wireless Bluetooth scanner to the system. Looking at how a operator works, we estimated that he/she would be able to scan around 5 boxes in 3 seconds. Using that information, we identified the right amount of information captured during the scan and automated the rest of it via the backend system.</p>
                                        <p className="implementation-contnet text-white   poppins m-0    fs_16">Yes, it was successful task.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-1">
                    </div>
                    <div className="col-12 col-md-6 mt-5">
                        <div className="background-setting tracking-speed-background my-4 p-0">
                            <div className="inventory-backdrop p-0" >
                                <div className=" py-5 px-3 px-md-5">
                                    <div className="container">
                                        <p className="sales-text text-white  fs_30 poppins m-0 pb-4   ">Tracking Serialized <br />Goods in Loose Boxes</p>
                                        <p className="implementation-contnet  text-white f  poppins m-0   pb-4 fs_16">Majority of the goods are sold in boxes. However, there are some goods that are sold as loose items. Meaning, while the box might hold 60 bottles of health supplements, some customers might only want to get 10 samples.

                                        </p>
                                        <p className="implementation-contnet text-white   poppins m-0 fs_16">Meanwhile, you can’t expect the warehouse to scan the remaining 50 bottles if they sell them all at one go, right? Hence, the task was to be able to still scan the box label and know the 50 serial numbers that remained in the box.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 mt-5 d-flex align-items-center">
                        <div className=" background-setting tracking-individual-background my-4 p-0">
                            <div className="inventory-backdrop p-0" >
                                <div className=" py-5 px-3 px-md-5">
                                    <div className="container">
                                        <p className="sales-text text-white text-end fs_32 poppins m-0 pb-4">Tracking Individual Sold Item from Start to End</p>
                                        <p className="implementation-contnet text-end  text-white f  poppins m-0   pb-4 fs_16">As you can imagine, this would have been the ultimate goals from the start. However, when combined with all the challenges above, the system had to be modified in order to achieve the same results.
                                        </p>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12  mt-3 mt-md-5 px-0 px-md-5">
                        <div className="background-setting  case3-result-background my-4 p-0">
                            <div className="inventory-backdrop p-0" >
                                <div className=" py-5 px-3 px-md-5">
                                    <div className="container">
                                        <p className="text-center text-white  fs_32 poppins m-0 pb-4 ">The Result</p>
                                        <p className="result-contnet  text-white f  poppins m-0  py-4 fs_16 px-3 px-md-5">SmartB successfully overcame the obstacles that came with the factory environment as well as some challenges from the above average processes that was in place.

                                        </p>
                                        <p className="result-contnet text-white   poppins m-0 fs_16 pt-4 px-3 px-md-5">This is important as many implementations in that has failed (in the market) not due to the capabilities of the systems but due to the inability to overcame challenges on the ground.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                {/* case 4 */}
                <div className="background-setting case4-banner-background p-0">
                    <div className="inventory-backdrop p-0" >
                        <div className="py-3 my-5">
                            <p className=" text-white fs_19 px-5 poppins m-0 pb-3  ">Case 4:</p>
                            <p className="text-center text-white fs_22  poppins m-0 pb-3  ">Multi Regional Multi Currency Integrated Display</p>
                        </div>
                    </div>
                </div>
                <div className="sales-module_heading case-4 mt-5 ">
                    <p className="benefit-text text-white poppins fs_30">Client Requirement</p>
                </div>
                <div className="row w-100 my-5  ">
                    <div className="case-4-text col-12 col-md-7 p-5">
                        <p className=" text-white  poppins fs_16 ls_2">The client, Inhesion Industrial (M) Sdn. Bhd. (IM), is a tableware manufacturer who was trying to implement an end-to-end ERP system which predominantly include the Sales, Product Development, Production, Inventory and Accounting modules. </p>
                        <p className="text-white poppins fs_16 ls_2">Use Case 2 (see above) was also a project for Inhesion. However, this is for Inhesion Asia (IA) which is predominantly the commercial/ sales team.
                        </p>
                    </div>
                    <div className="col-12 col-md-5">
                    </div>
                </div>
                <div className="sales-module_heading case-4 mt-5 ">
                    <p className="benefit-text text-white poppins fs_30">The Challenge</p>
                </div>
                <div className="row w-100 my-5  ">
                    <div className="case-4-text col-12 col-md-11 p-5">
                        <p className=" text-white  poppins fs_16 ls_2">IA is a Hong Kong based company. However, they have they have an extensive worldwide sales channel – which covers Hong Kong, China, France, Macao and America. With such a large sales network, they needed a system which could provide the following information conveniently.
                        </p>
                        <ul className="py-3">
                            <li className="text-white poppins fs_16">Visibility of stock availability (to determine the lead delivery time)
                            </li>
                            <li className="text-white poppins fs_16">Price (for various regions HKD, MYR, USD and etc)
                            </li>
                            <li className="text-white poppins fs_16 ">Controls and authorization (from various Head of Department) – for changing prices and for tiered pricing model
                            </li>
                            <li className="text-white poppins fs_16 ">Production information – for specific sales channels

                            </li>
                            <li className="text-white poppins fs_16 ">Product information – for all visitors
                                Ï </li>
                        </ul>
                        <p className="text-white poppins fs_16 ls_2">All the above information needs to be provided for each individual product code (or SKU).</p>
                    </div>
                    <div className="col-12 col-md-1">
                    </div>
                    <div className="col-12 px-5">
                        <img src={casegraph} width="100%" alt="Your Image" />
                    </div>
                    <div className="case-4-text col-12 col-md-7 p-5 mt-5">
                        <p className=" text-white  poppins fs_16 ls_2">The diagram above is a simplified matrix of how the information is accessible based on:
                        </p>
                        <ul className="">
                            <li className="text-white poppins fs_16">The users’ level of authority
                            </li>
                            <li className="text-white poppins fs_16">The region where the user is registered
                            </li>
                            <li className="text-white poppins fs_16 ">The type of product information
                            </li>
                        </ul>
                    </div>
                    <div className="col-12 col-md-5">
                    </div>

                </div>
                <div className="sales-module_heading case-4 mt-5 ">
                    <p className="benefit-text text-white poppins fs_30">Implementation</p>
                </div>
                <div className="row">
                    <div className="case-4-text col-12 col-md-8 p-4 mt-5">
                        <p className=" text-white  poppins m-0 fs_16 ls_2 ">The diagram above is a simplified matrix of how the information is accessible based on:
                        </p>
                    </div>
                    <div className="col-12 col-4">
                    </div>
                    <div className="col-12 col-md-8 mt-5">
                        <div className="background-setting factory-background my-4 p-0">
                            <div className="inventory-backdrop p-0" >
                                <div className=" py-5 px-3 px-md-5">
                                    <div className="container">
                                        <p className="sales-text text-white  fs_30 poppins m-0 pb-4">Scanning Location In Each Factory</p>
                                        <p className="implementation-contnet  text-white f  poppins m-0   pb-4 fs_16">Similar to the project which we implemented with VAsia, each QR Code is displaying a URL link instead of a product ID (or code). When scanned, you will be directed to a web catalogue that would look similar to this (below).
                                        </p>
                                        <p className="implementation-contnet text-white   poppins m-0   pb-4 fs_16">Here, all viewers can see the generic information of that specific product. At this stage, all you need is a mobile web browser and any one can view this page.
                                        </p>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-4 d-flex align-items-center pt-md-5 pt-0  mt-sm-4">
                        <img src={inhension} width="100%" />
                    </div>

                    <div className="col-12 col-md-6 mt-5">
                        <div className="background-setting profiles-background my-4 p-0">
                            <div className="inventory-backdrop p-0" >
                                <div className=" py-5 px-3 px-md-5">
                                    <div className="container">
                                        <p className="sales-text text-white  fs_32 poppins m-0 pb-4">Pre-defined Profiles</p>
                                        <p className="implementation-contnet  text-white f  poppins m-0  pb-4 fs_16">In order to manage and restrict the information accessible by the individual, all users will have a pre-defined user profile. Essentially, the profile is based on the level of accessibility they should have and the region (or country) in which they are in.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6"> </div>
                    <div className="col-12 col-md-7 my-5 background-setting code-label-background my-4  p-0">
                        <div className="inventory-backdrop p-0" >
                            <div className="container">
                                <div className="py-5 px-3 px-md-5">
                                    <p className="sales-text text-white  fs_30 poppins m-0 pb-4 ">
                                        QR Code Label</p>
                                    <p className=" text-white   poppins m-0 fs_16  ">Before anyone could view anything, the first thing to do was the establish how the correct data would be displayed (given that there are thousands of products being in the system that can be sold).
                                    </p>
                                    <p className=" text-white   poppins m-0 fs_16  ">The easiest thing to do was to label each of the product with a barcode. In this case, a QR bar code was used.
                                    </p>
                                    <p className=" text-white   poppins m-0 fs_16  ">The label can be printed on a sticker label. It is as small as 2.5 cm x 3.5 cm and, due to the size of the QR code, a high-resolution printer must be used (min of 300dpi).
                                    </p>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-5 qrcode_image d-flex align-items-center justify-content-center">
                        <img src={qrcode} width="200px" alt="Your image" />
                    </div>
                </div>
                <div className="row w-100 my-5 ">
                    <div className="col-12 col-md-7 background-setting conversion-background my-4 p-0">
                        <div className="inventory-backdrop p-0" >
                            <div className="container">
                                <div className="py-5 px-3 px-md-5">
                                    <p className="sales-text text-white  fs_30 poppins m-0 pb-4 ">
                                        QR Code-URL -Stock Number Conversion</p>
                                    <p className="implementation-descrption text-white   poppins m-0 fs_16  pb-3">We successfully created a mobile app that reads new product QR codes on-the-go and it is integrated with:
                                    </p>

                                    <ul className="py-3">
                                        <li className="text-white poppins fs_16">Sales information
                                        </li>
                                        <li className="text-white poppins fs_16">Production information
                                        </li>
                                        <li className="text-white poppins fs_16 ">Inventory information
                                        </li>
                                    </ul>
                                    <p className="implementation-descrption text-white   poppins m-0 fs_16 pb-4 ">With that, it means we can display all the information required by the sales team when in front of the client irrespective of where they are in the world.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-5 d-flex align-items-center pt-md-5 pt-0  mt-sm-4 sales-module_image ">
                        <img src={urlstock} width="100%" alt="Your image" />
                    </div>
                </div>

                <div className="background-setting case5-banner-background">
                    <div className="inventory-backdrop p-0" >
                        <div className="py-3 my-5">
                            <p className=" text-white fs_19 px-5 poppins m-0 pb-3  ">Case 5:</p>
                            <p className="text-center text-white fs_22  poppins m-0 pb-3  ">Production Scheduling Optimisation (System) Modelling</p>
                        </div>
                    </div>
                </div>
                <div className="sales-module_heading case-5 mt-5 ">
                    <p className="benefit-text text-white poppins fs_30">Client Requirement</p>
                </div>
                <div className="row w-100 my-5  ">
                    <div className="case-5-text col-12 col-md-11 p-5">
                        <p className=" text-white  poppins fs_16 ls_2 pb-4">The client, Taiko Marketing Sdn Bhd is the only supplier in Malaysia to produce Chlor-Alkali AND Sulphur Derivative chemicals.
                        </p>
                        <p className="text-white poppins fs_16 ls_2 pb-4">And they were trying to (1) optimise their production while juggling to balance between short-term fluctuating production demand, (2) managing production priorities and (3) managing manpower overtime cost.
                        </p>
                        <p className="text-white poppins fs_16 ls_2">In short, it was as if they need an Artificial Intelligent (Ai) to tell them how to prioritise their production orders. Unfortunately, most ERP systems would not have a module that is suitable for Taiko, while those that may have it, usually ends up costing too much.
                        </p>
                    </div>
                    <div className="col-12 col-md-1">
                    </div>
                </div>
                <div className="sales-module_heading case-5 mt-5 ">
                    <p className="benefit-text text-white poppins fs_30">The Challenge</p>
                </div>
                <div className="row w-100 my-5  ">
                    <div className="case-5-text col-12 col-md-10 p-5">
                        <p className=" text-white  poppins fs_16 ls_2 pb-4">Apart from having a tight budget, Taiko needed a SmartB to help them formulate the algorithm to significantly reduce non-production activities (e.g. switching and/or setting up new machines) while regularly updating the production priority based on short-term urgent requests.
                        </p>
                        <p className="text-white poppins fs_16 ls_2 pb-4">If this was not hard enough, it took Taiko a significant amount of time to conceptualise what they needed as this module was very new to them. Basically, they had a vision of what they wanted, but didn’t know how to explain it in simple terms.
                        </p>
                        <p className="text-white poppins fs_16 ls_2 ">Note: In order to maintain confidentiality, the information in this case were altered. However, rest assured that the complexity of the requirements remains at similar levels.
                        </p>
                    </div>

                    <div className="col-12 col-md-5 mt-5">
                        <div className="background-setting implementation-background my-4 p-0">
                            <div className="inventory-backdrop p-0" >
                                <div className=" py-5 px-5">
                                    <div className="container">
                                        <p className=" text-center sales-text text-white  fs_30 poppins m-0 pb-4">Implementation</p>
                                        <p className="text-center implementation-contnet  text-white poppins m-0 pb-4 fs_16">In order to resolve this challenge, the project had to be implemented with a sequence of activities.
                                        </p>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="background-setting sequence-background my-4 p-0">
                            <div className="inventory-backdrop p-0" >
                                <div className=" py-5 px-3 px-md-5">
                                    <div className="container">
                                        <p className=" 
                                        sales-text text-white  fs_30 poppins m-0 pb-4">Sequence <br /> Automation</p>
                                        <p className=" implementation-contnet  text-white poppins m-0 pb-4 fs_16">As the project was complex, the need to remain focus was crucial. So, instead of building a “robot”, the idea was to focus what was important.

                                        </p>
                                        <p className=" implementation-contnet  text-white poppins m-0 pb-4 fs_16">That means, we focused on optimising the production sequence only. And that would have meant that the bulk of the requirements would have been met.


                                        </p>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-7 mt-3 mt-md-5 ">
                        <div className="background-setting planning-background my-4 p-0">
                            <div className="inventory-backdrop p-0" >
                                <div className=" py-5 px-3 px-md-5">
                                    <div className="container">
                                        <p className=" text-center sales-text text-white  fs_32 poppins m-0 pb-4   ">Scenario Planning</p>
                                        <p className="implementation-contnet  text-white   poppins m-0 pb-4 fs_16">The first part of the project was to help the client clarify the parameters of the system that they wanted.
                                            This includes listing down as many “what if” scenarios as possible.

                                        </p>
                                        <p className="implementation-contnet text-white   poppins m-0 pb-4 fs_16">As more scenarios were identified, new potential challenges/ outcomes started to unveil itself. More importantly, we had to rectify some of the issues from those outcomes, and decisions had to be made in terms of controls and management of those outcomes.
                                        </p>
                                        <p className="implementation-contnet text-white   poppins m-0 pb-4  fs_16">Blind Spots
                                        </p>
                                        <p className="implementation-contnet text-white   poppins m-0 pb-4  fs_16">The real benefit of modelling the system was that it gave both the client and SmartB an opportunity to see the “blind spots” that we would not have envisage unless we saw the model in action.

                                        </p>
                                        <p className="implementation-contnet text-white   poppins m-0 fs_16">From that, we generated supporting databases to ensure that the main algorithms would function as planned.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div className=" mt-3 mt-md-5">
                    <div className="background-setting advance-level-background my-4 p-0">
                        <div className="inventory-backdrop p-0" >
                            <div className=" py-5 px-3 px-md-5">
                                <div className="container">
                                    <p className="text-center text-white  fs_32 poppins m-0 pb-4 ">Advance Level MS Excel</p>
                                    <p className="result-contnet  text-white f  poppins m-0  py-4 fs_16 px-0 px-md-5">In order to maintain relatively low cost, a MS Excel model was built in order to mimic the desired system. To a certain extent, we were prototyping the potential system that was required.
                                    </p>
                                    <p className="result-contnet text-white   poppins m-0 fs_16 pt-4 px-0 px-md-5">In order to mimic an ERP system, MS Excel Macro and Visual Basic for Applications (VBA) were used.
                                    </p>
                                    <p className="result-contnet text-white   poppins m-0 fs_16 pt-4 px-0 px-md-5">Note: Explanations were given at every stage in order to ensure that client was aware of the difference between what was shown in the MS Excel and how the system was function (if one was built).
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="sales-module_heading case-5 mt-5 ">
                    <p className="benefit-text text-white poppins fs_30">The Result</p>
                </div>
                <div className="row w-100 my-5  ">
                    <div className="case-5-text col-12 col-md-7 p-5">
                        <p className=" text-white  poppins fs_16 ls_2 pb-4">TThe end result was that the client started to use the MS Excel as part of their daily operations. The model was a success as it provided a clear structure of what was required in the event a system was built.

                        </p>
                        <p className="text-white poppins fs_16 ls_2 pb-4">The following video shows a section of the entire model.

                        </p>
                        <p className="text-white poppins fs_16 ls_2">Note: At the point of writing this case, Malaysia is going through a Movement Control Order (MCO) due to the Covid-19 virus. Hence, the system was not built yet but the model is already in use as a tentative solution.
                        </p>
                    </div>
                    <div className="col-12 col-md-5">
                    </div>
                </div>
                <div className="sales-module_heading case-5 mt-5 ">
                    <p className="benefit-text text-white poppins fs_30">Watch Video To Learn More</p>
                </div>
                <div className=" mt-3 mt-md-5">
                    
                            <div className=" py-3 px-3 px-md-5">
                                <div className="container">
                                <iframe width="100%" height="315" src="https://www.youtube.com/embed/fkNr5-OhMVo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                                </div>
                            </div>
                   
                </div>
               
                {/* Case-6 */}
                <div className="background-setting case6-banner-background">
                    <div className="inventory-backdrop p-0" >
                        <div className="py-3 my-5">
                            <p className=" text-white fs_19 px-5 poppins m-0 pb-3  ">Case 6:</p>
                            <p className="text-center text-white fs_22  poppins m-0 pb-3  ">Optimizing the Cutting Sequence To Reduce Wastage</p>
                        </div>
                    </div>

                </div>
                <div className="sales-module_heading case-6 mt-5 ">
                    <p className="benefit-text text-white poppins fs_30">Client Requirement</p>
                </div>
                <div className="row w-100 my-5  ">
                    <div className="case-6-text col-12 col-md-7 p-5">
                        <p className=" text-white  poppins fs_16 ls_2 pb-4">The client, LTI Resources Sdn Bhd (LTI), is one of the leading self-adhesive tape manufacturers in Malaysia with in-house R & D, design and converting facilities. </p>
                        <p className="text-white poppins fs_16 ls_2 pb-4">LTI approached us to help them optimized their cutting sequence as the current process incurs a high amount of wastage.</p>
                    </div>
                    <div className="col-12 col-md-5 pt-4 pt-md-0 sales-module_image">
                        <img src={clienttable} width="100%" alt="Your Image" />
                    </div>
                </div>
                <div className="sales-module_heading case-6 mt-5 ">
                    <p className="benefit-text text-white poppins fs_30">The Challenge</p>
                </div>
                <div className="row w-100 my-5  ">
                    <div className="case-6-text col-12 col-md-7 p-5">
                        <p className=" text-white  poppins fs_16 ls_2 ">In order to explain their challenge, here is a simple customer order that will, hopefully, illustrate the problem – Note that these have been modified to maintain confidentiality.
                        </p>

                    </div>
                </div>
                <div className="sales-module_heading case-6 mt-5 ">
                    <p className="benefit-text text-white poppins fs_30">Sample Customer Order</p>
                </div>
                <div className="row w-100 my-5  ">
                    <div className="case-6-text col-12 col-md-7 p-5">
                        <p className=" text-white  poppins fs_16 ls_2 pb-4">LTI receives a mix order from a regular client for the following:
                        </p>
                        <p className="text-white poppins fs_16 ls_2 m-0">12mm x 50m = 100 rolls </p>

                        <p className="text-white poppins fs_16 ls_2 m-0">18mm x 50m = 120 rolls
                        </p>
                        <p className="text-white poppins fs_16 ls_2 m-0 ">24mm x 50m = 200 rolls
                        </p>
                        <p className="text-white poppins fs_16 ls_2 m-0">36mm x 50m = 110 rolls
                        </p>
                        <p className="text-white poppins fs_16 ls_2 m-0 pb-4">Existing Stock Balance
                        </p>
                        <p className=" text-white  poppins fs_16 ls_2 pb-4">LTI receives a mix order from a regular client for the following:
                        </p>
                        <p className="text-white poppins fs_16 ls_2 m-0 ">200mm x 50m = 150 rolls
                        </p>
                    </div>
                    <div className="col-12 col-md-5 pt-4 pt-md-0 sales-module_image">
                        <img src={stockcutting} width="100%" alt="Your Image" />
                    </div>
                    <div className="col-12 col-md-5 mt-5">
                        <div className="background-setting challenge-background my-4 p-0">
                            <div className="inventory-backdrop p-0" >
                                <div className=" py-5 px-3 px-md-5">
                                    <div className="container">
                                        <p className=" text-center sales-text text-white  fs_30 poppins m-0 pb-4">The Challenge</p>
                                        <p className="text-center implementation-contnet  text-white poppins m-0 pb-4 fs_16">Which existing stock should LTI use to ensure that there is minimal leftover/waste? And how should LTI combine the size when they cut the rolls?
                                        </p>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="col-12 col-md-7 mt-3 mt-md-5">
                        <div className="background-setting case6-implementation-background my-4 p-0">
                            <div className="inventory-backdrop p-0" >
                                <div className=" py-5 px-3 px-md-5">
                                    <div className="container">
                                        <p className=" text-center sales-text text-white  fs_30 poppins m-0 pb-4   ">Implementation</p>
                                        <p className="implementation-contnet  text-white   poppins m-0 pb-4 fs_16">In order to resolve this challenge, the issue needs to be solve using mathematical logics. Here’s a visual illustration of how we can solve the problem:
                                        </p>
                                        <p className="implementation-contnet text-white   poppins m-0 pb-4 fs_16">As shown above, in order to optimize the cutting process, an intelligent system was developed in order to find the combination of sequence that produced the least wastage.
                                        </p>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="sales-module_heading case-6 mt-5 ">
                    <p className="benefit-text text-white poppins fs_30">The Result</p>
                </div>
                <div className="row w-100 my-5  ">
                    <div className="case-6-text col-12 col-md-7 p-5">
                        <p className=" text-white  poppins fs_16 ls_2 p-0 m-0">The end result was that we built a system that could automatically calculate the best cutting combination and this could be done within seconds.
                        </p>

                    </div>
                </div>
                <RequestForm />
                <div className="background-setting bg-black py-5">
                    <Footer />
                </div>
            </div>
        </>
    );
}

export default Story;